var _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPromartMobile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "promart-mobile",
    width: 64,
    height: 52,
    viewBox: "0 0 64 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 52,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40.7502 28.1998C40.1831 28.1998 39.616 27.9746 39.2036 27.5589L32.0206 20.318L24.8377 27.5589C23.9784 28.425 22.6037 28.425 21.7445 27.5589C20.8853 26.6927 20.8853 25.3069 21.7445 24.4408L30.4741 15.6409C30.8865 15.2252 31.4364 15 32.0206 15C32.6049 15 33.1548 15.2252 33.5672 15.6409L38.5678 20.6818V19.3999C38.5678 18.1874 39.5473 17.2 40.7502 17.2C41.9531 17.2 42.9326 18.1874 42.9326 19.3999V25.9998C42.9326 26.8833 42.3999 27.6974 41.5922 28.0266C41.3173 28.1478 41.0251 28.1998 40.7502 28.1998Z",
    fill: "#FF8000"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M40.7506 37H23.2915C22.0886 37 21.1091 36.0126 21.1091 34.8001C21.1091 33.5875 22.0886 32.6001 23.2915 32.6001H40.7506C41.9535 32.6001 42.933 33.5875 42.933 34.8001C42.933 36.0126 41.9535 37 40.7506 37Z",
    fill: "#FF8000"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPromartMobile);
export default __webpack_public_path__ + "static/media/promart_mobile.f6e832e0a460082f67a06c42c7797c64.svg";
export { ForwardRef as ReactComponent };